import styled from "@emotion/styled";
import { IconButton, TableCell, TableRow, tableCellClasses } from "@mui/material"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        backgroundColor: "#f5f5f5",
        fontSize: 15,
    },
}));

const CustomerList = ({ customer, handleClick }) => {
    return <TableRow >
        <StyledTableCell align="center">{customer.customerNumber}</StyledTableCell>
        <StyledTableCell align="center">{customer.customerName}</StyledTableCell>
        <StyledTableCell align="center">{(customer.customerBalance).toLocaleString()}</StyledTableCell>
        <StyledTableCell align="center">
            <IconButton size="large" onClick={() => handleClick(customer)}><AccountCircleIcon /></IconButton>
        </StyledTableCell>
    </TableRow>

}

export default CustomerList